import { AutoComplete, AutoCompleteProps } from 'antd'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { stagesAtom } from '@/modules/project/project-detail/project-stages/stages.atom'

export const StageSearch: React.FC<AutoCompleteProps> = React.forwardRef((props, ref) => {
  const { i18n } = useTranslation()

  const [stages] = useAtom(stagesAtom)

  if (!stages) {
    return null
  }

  return (
    <AutoComplete
      ref={ref as any}
      allowClear
      backfill
      options={stages.map((d: any) => ({
        label: i18n.resolvedLanguage === 'zh' ? d.name : d.ename || d.name,
        value: i18n.resolvedLanguage === 'zh' ? d.name : d.ename || d.name,
      }))}
      filterOption={(s, o: any) => o.label.includes(s)}
      {...props}
    ></AutoComplete>
  )
})
